import React, { Fragment, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import { Col, Modal, Row } from "react-bootstrap";
import { useFormik } from "formik";
import { Button } from "../../common/Button";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import Fields from "./Fields";
import { getOrganization, getOrganizationSettings } from "../../api/Organization";
import { useSelector } from "react-redux";
import { failed, success } from "../../common/Toastify";
import { axios } from "../../../lib/axios";
import { FormikObjInboundCall } from "./Constant";
import moment from "moment";
import PatientSelection from "./PatientSelection";
import AddPatient from "./AddPatient";
import AddToWaitingRoomModal from "./AddToWaitingRoomModal";
import { useNavigate } from "react-router-dom";
import { createQuestionnaireResponse, editQuestionnaireResponse, getQuestionnaireById } from "../../api/Questionnaire";
import { evaluateCondition } from "../../../utils/questionnaireSupport";
import { getSingleUser, updatePatientDemographics, createExternalRegistryUser } from "../../api/Individual";
import { LOCATIONS } from "../../common/location";
import { getServiceLineById, getServiceLinesByOrgId } from "../../api/ServiceLine";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { createEncounterInbound, editEncounter } from "../../apps/api/Encounter";
import { Resources } from "../../Zoom/Resources";

// changed to make steps language independant and step count independant
const ALL_STEPS = [
  {
    label: "Select Organization",
    key: "ORGANIZATION"
  },
  {
    label: "Intake Questionnaire",
    key:"QUESTIONS"
  },
  {
    label: "Patient Selection",
    key: "PATIENT"
  }
];
export const genderOptions = [
  { value: "male", name: "Male" },
  { value: "female", name: "Female" },
  { value: "other", name: "Other" },
];

export default function InBoundCall({
  encounterId: incomingEncounterId = null,
  encounteredData: incomingEncounterData = null,
  modalShow,
  handleShow,
}) {
  const user = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [disabledNext, setDisabledNext] = useState(false);
  const [isOrgReadOnly, setisOrgReadOnly] = useState(incomingEncounterId ? true : false);
  const [activeStep, setActiveStep] = useState(ALL_STEPS.find(item => item.key === "ORGANIZATION"));
  const [steps, setSteps] = useState(ALL_STEPS);
  const [patientModal, setPatientModal] = useState(false);
  const [skipped, setSkipped] = useState(new Set());
  const [Questions, setQuestions] = useState([]);
  const [questionnaireDefinition, setQuestionnaireDefinition] = useState(null);
  const [visibleQuestions, setVisibleQuestions] = useState([]);
  const [questionResponseKey, setQuestionResponseKey] = useState(0);
  const [waitingRoomPayload, setWaitingRoomPayload] = useState(null);
  const waitingRoomOpen = useRef(false);
  waitingRoomOpen.current = Boolean(waitingRoomPayload);
  const intakeAction = useRef("COMPLETE_CALL");
  const submissionInFlight = useRef(false);
  const [organizations, setOrganizations] = useState([]);
  const [radioValue, setRadioValue] = useState([]);
  const [patient, setPatient] = useState(null);
  const [questionnairResId, setQuestionnairResId] = useState("");
  const [practitionerData, setPractitionerData] = useState(null);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [availableServiceLines, setAvailableServiceLines] = useState([]);
  const { getConfirmation } = useConfirmDialog();
  const userRoles = user?.["cognito:groups"];
  const admin = userRoles?.includes("Super-Admin");
  const permissions = user?.permissions;
  const hasResourcesReadPermissions = admin || permissions?.some(permission => permission === "Access Resource Hub");
  const [resourceModalShow, setResourceModalShow] = useState(false);
  const [encounterId, setEncounterId] = useState(incomingEncounterId);
  const [encounteredData, setEncounteredData] = useState(incomingEncounterData);
  const [organizationSettings, setOrganizationSettings] = useState(null);
  const [allOrgData, setAllOrgData] = useState(null);
  const [intakeReadyFor, setIntakeReadyFor] = useState("");
  const formik = useFormik({
    ...FormikObjInboundCall,
    enableReinitialize: true,
    onSubmit: async (values, { setFieldError }) => {
      if (activeStep.key === "ORGANIZATION") {
        if (values?.orgId === "") {
          setFieldError(`orgId`, "Required field");
          setDisabledNext(true);
          return true;
        } else if (values?.serviceLineId === "") {
          setFieldError(`serviceLineId`, "Required field")
          setDisabledNext(true);
          return true;
        } else {
          setDisabledNext(false);
          // setActiveStep(steps[steps.findIndex(step => step.key === "ORGANIZATION") + 1]);
        }
        if(!encounterId) {
          let encounterPayload = {
            orgId: values?.orgId,
            orgName: values?.orgName.trim(),
            requestedPeriod: {start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"), end: null},
            practitionerId: user?.["custom:practitioner_id"] ?? practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1],
            practitionerName: practitionerData?.name?.[0]?.text.trim(), 
            status: "in-progress-intake",
            statusHistory: [{
                status: "in-progress-intake",
                actor: {
                    reference: practitionerData?.link?.[0]?.target?.reference,
                    display: practitionerData?.name?.[0]?.text,
                },
                period: {
                    start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                    end: null
                }
            }] 
          }
          return createEncounterInbound(encounterPayload).then((res)=>{
              if(res.status === true){ 
                setEncounterId(res.data.id); 
                setEncounteredData(res.data);
                setisOrgReadOnly(true);
              }else{
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message) 
                return true;
              }
          }).catch((res) => { 
              failed(res?.response?.data?.message || res?.response?.data?.error || res.message)
              return true;
          }).finally();
        } else {
          setisOrgReadOnly(true);
        }
      } else if (activeStep.key === "QUESTIONS") {
        const telePhoneField = formik?.values?.questionResponse?.find(
          (item) => item?.tag === "TELEPHONE"
        )?.answer?.[0]?.answer;
        const pattern =
          /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/;
        const errList = values?.questionResponse?.map((question, index) => {
          if (visibleQuestions[index] && question?.required) {
            if (question?.answerType === "radio") {
              if (!question?.answer?.some((item) => !!item?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
            } else if (
              question?.answerType === "freeText" ||
              question?.answerType === "singleFreeText" ||
              question?.answerType === "dropDown"
            ) {
              // if (question?.answer?.[0]?.answer?.length < 1 || !question?.answer?.[0]?.answer?.replace(/\s/g, "").length || question?.answer?.[1]?.answer?.length < 1 || !question?.answer?.[1]?.answer?.replace(/\s/g, "").length) {
              if (
                question.tag === "RELATIONSHIP" &&
                question?.answerType === "dropDown"
              ) {
                if (
                  question?.answer[0]?.answer === "" &&
                  radioValue.some(
                    (option) =>
                      option?.answer === true && option?.option === "No"
                  )
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              } else if (
                question.tag !== "RELATIONSHIP" &&
                question?.answerType === "dropDown" &&
                question?.answer[0]?.answer === ""
              ) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
              if (
                (question?.answerType === "freeText" || question?.answerType === "singleFreeText") &&
                question?.tag === "CALLER"
              ) {
                if (
                  question?.answer?.[0]?.answer === "" ||
                  question?.answer?.[0]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
                if (
                  question?.answer?.[1]?.answer === "" ||
                  question?.answer?.[1]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              } else if (
                (question?.answerType === "freeText" || question?.answerType === "singleFreeText") &&
                question?.tag !== "CALLER"
              ) {
                if (
                  question?.answer?.[0]?.answer === "" ||
                  question?.answer?.[0]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              }

              // }
            } else if (question?.answerType === "checkbox") {
              if (!question?.answer?.some((item) => !!item?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
            }
          }
          return false;
        });

        if (
          formik?.values?.questionResponse?.length === 0 ||
          formik?.values?.questionResponse?.length === undefined ||
          formik?.values?.questionResponse?.length === null
        ) {
          return true;
        }
        if (errList.some(Boolean) || !pattern.test(telePhoneField)) {
          return true;
        }


        localStorage.setItem(
          "firstName",
          values?.questionResponse.find((obj) => obj.tag === "CALLER")
            ?.answer?.[0]?.answer
        );
        localStorage.setItem(
          "lastName",
          values?.questionResponse.find((obj) => obj.tag === "CALLER")
            ?.answer?.[1]?.answer
        );
      } else if (activeStep.key === "PATIENT") {
        if (!encounterId) {
          failed("Create the encounter before proceeding.");
          return true;
        }
        if (intakeAction.current === "WAITING_ROOM" && !isWaitingRoom) {
          failed("Waiting room is not enabled for the selected organization.");
          return true;
        }
        if (values?.patientId === "" && values?.selectedPatientData === "") {
          setFieldError(`patientId`, "Select patient before proceeding");
          return true;
        }

        // ECR org: may need to create EXT patient or apply accepted EXT demographics before routing the encounter.
        // Async paths must await and return true on failure so handleNext does not skip ahead.
        const selectedPatientData = values?.selectedPatientData;
        let nextValues = values;

        if (selectedPatientData && organizationSettings?.ecrEnabled === true) {
          const sources = Array.isArray(selectedPatientData?.source)
            ? selectedPatientData.source
            : selectedPatientData?.source
              ? [selectedPatientData.source]
              : [];
          const isExtOnly = sources.length === 1 && sources.includes("EXT");
          const isMatched = sources.includes("EXT") && sources.includes("FLZ");
          const hasDiscrepancy = !!selectedPatientData?.hasDemographicDiscrepancy;
          const demographicChoice = values?.demographicChoice;

          if (isMatched && hasDiscrepancy && !demographicChoice) {
            setFieldError(
              `patientId`,
              "Accept either local (FLZ) or Client Registry (EXT) demographics before proceeding"
            );
            return true;
          }

          if (isMatched && hasDiscrepancy && demographicChoice === "EXT") {
            // Update patient demographics from accepted EXT values (identifiers excluded)
            setBtnLoading(true);
            const external = selectedPatientData?.external || {};
            const dob = moment(external?.birthDate).format("MM-DD-YYYY");

            const payload = {
              birthDate: dob !== "Invalid date" ? dob : "",
              firstName: external?.name?.[0]?.given?.[0]?.trim() || "",
              lastName: external?.name?.[0]?.family?.trim() || "",
              gender: external?.gender?.trim() || "",
              managingOrganization: values?.orgId,
              telecom: external?.telecom || [],
              address: external?.address || [],
              // Keep existing local identifiers (read-only; do not apply EXT identifier overwrite)
              identifier: selectedPatientData?.identifier || [],
              source: "EXT",
              // Audit keyword for patient service logging: user accepted EXT over local FLZ demographics
              auditAction: "USER_ACCEPTED_EXT_DEMOGRAPHICS_OVERRIDE",
            };

            try {
              const res = await updatePatientDemographics(
                values?.patientId,
                values?.orgId,
                payload
              );
              if (res?.status === true) {
                const externalName =
                  external?.name?.[0]?.text?.trim() ||
                  [external?.name?.[0]?.given?.[0], external?.name?.[0]?.family]
                    .filter(Boolean)
                    .join(" ")
                    .trim() ||
                  values?.patientName;
                // Encounter subject/participant display must use accepted EXT name
                await formik.setFieldValue("patientName", externalName);
                nextValues = { ...nextValues, patientName: externalName };
                success(res?.message || "Patient demographics updated successfully");
              } else {
                failed(res?.error || "Failed to update patient demographics");
                return true;
              }
            } catch (err) {
              failed(
                err?.response?.data?.message ||
                  err?.response?.data?.error ||
                  err?.message ||
                  "Error updating patient demographics"
              );
              return true;
            } finally {
              setBtnLoading(false);
            }
          }

          if (isExtOnly && !selectedPatientData?.id) {
            // Pure ECR hit (no FLZ id yet) — create local patient from EXT demographics
            setBtnLoading(true);
            const email =
              selectedPatientData?.telecom?.find((t) => t?.system === "email")?.value ||
              "";
            const firstIdentifier =
              selectedPatientData?.identifier?.find((item) => item?.type === "HCN") ||
              selectedPatientData?.identifier?.[0];
            const cleanedIdentifier = firstIdentifier
              ? (() => {
                  const { source, ...identifierWithoutSource } = firstIdentifier;
                  return [
                    {
                      ...identifierWithoutSource,
                      type: "HCN",
                    },
                  ];
                })()
              : [];

            const payload = {
              type: "Patient",
              name: selectedPatientData?.name,
              gender: selectedPatientData?.gender?.trim() || "",
              birthDate: selectedPatientData?.birthDate,
              telecom: selectedPatientData?.telecom,
              address: selectedPatientData?.address,
              managingOrganization: values?.orgId,
              identifier: cleanedIdentifier,
              email: email?.trim(),
              createAccount: false,
              source: "EXT",
              healthCardNumber: firstIdentifier?.value || "",
              healthCardAuthority: firstIdentifier?.system || "",
            };

            try {
              const res = await createExternalRegistryUser(
                payload,
                values?.orgId,
                organizations
              );
              if (res?.status === true) {
                const newPatientId =
                  res?.data?.link?.[0]?.target?.reference?.split("/")?.[1] || "";
                if (!newPatientId) {
                  failed(
                    "Patient was created but no patient id was returned. Please try again."
                  );
                  return true;
                }
                await formik.setFieldValue("patientId", newPatientId);
                const localPatient = { ...selectedPatientData, id: newPatientId };
                await formik.setFieldValue("selectedPatientData", localPatient);
                nextValues = { ...nextValues, patientId: newPatientId, selectedPatientData: localPatient };
                success(res?.message || "User account created successfully");
              } else {
                failed(res?.error || "Failed to create user account");
                return true;
              }
            } catch (err) {
              failed(
                err?.response?.data?.message ||
                  err?.response?.data?.error ||
                  err?.message ||
                  "Error creating user account"
              );
              return true;
            } finally {
              setBtnLoading(false);
            }
          }
          // FLZ only, EXT already in FLZ (has id), matched without discrepancy, or Accept FLZ — no write
        }

        if (!nextValues?.patientId) {
          setFieldError(
            `patientId`,
            "Patient must be created or selected before proceeding"
          );
          failed("Patient id is missing. Go back to the patient step and try again.");
          return true;
        }

        return completeIntake(nextValues, intakeAction.current);
      }
    },
  });
  const isWaitingRoom = Boolean(allOrgData?.find(org => org.id === formik.values.orgId)?.isWaitingRoom);
  const isBusy = btnLoading || formik.isSubmitting;
  const intakeReady = Boolean(formik.values.orgId && formik.values.serviceLineId
    && intakeReadyFor === `${formik.values.orgId}:${formik.values.serviceLineId}`);

  // Warn on refresh/close : Warning only
  useEffect(() => {
    if (!modalShow || !encounterId) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [modalShow, disabledNext, encounterId]);

  // Handle browser back button - Use handleClose()
  useEffect(() => {
    if (!modalShow || !encounterId) return;

    const handlePopState = async (e) => {
      window.history.pushState(null, '', window.location.href);
      await handleClose(encounterId);
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [modalShow, encounterId]);

  const isTagPresent = (tagValue) =>
    formik?.values?.questionResponse?.some((item) => item.tag === tagValue);
  const getValueQuestionnair = (tagValue) =>
    formik?.values?.questionResponse?.find((item) => item.tag === tagValue)
      ?.answer?.[0]?.answer;
  const getValueQuestionnairDropDown = (tagValue) =>
    formik?.values?.questionResponse
      .find((obj) => obj?.tag === tagValue)
      ?.answer?.find((val) => val?.answer !== "")?.answer;
  const getValueQuestionnairRadio = (tagValue) =>
    formik?.values?.questionResponse
      .find((obj) => obj?.tag === tagValue)
      ?.answer?.find((val) => val?.answer === true)?.option;

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = async (submit = true, action = "COMPLETE_CALL") => {
    if (submissionInFlight.current || btnLoading) return;
    if (submit && (disabledNext || !intakeReady)) return;
    const isLast = steps.findIndex((step) => step.key == activeStep.key) === steps.length - 1;
    if(submit) {
      submissionInFlight.current = true;
      intakeAction.current = action;
      try {
        const res = await formik.submitForm();
        if(!res && !isLast) setActiveStep(steps[steps.findIndex(step => step.key == activeStep.key)+1] || steps[steps.length - 1])
      } finally {
        submissionInFlight.current = false;
        intakeAction.current = "COMPLETE_CALL";
      }
    }
    else if (!isLast) setActiveStep(steps[steps.findIndex(step => step.key == activeStep.key)+1] || steps[steps.length - 1])
  };

  const handleBack = () => {
    setActiveStep(steps[steps.findIndex(step => step.key == activeStep.key)-1] || steps[0])
  };

  const handleReset = () => {
    setActiveStep(steps[0]);
  };

  useEffect(() => {
    getOrganization()
      .then((res) => {
         if (res?.data) { 
          setAllOrgData(res.data);
          const allOrgs = res.data.map((org) => ({
            ...org,
            value: org.id,
          }));
          allOrgs.sort((a, b) => a.name.localeCompare(b.name));
          setOrganizations(allOrgs); 
          const adminOrg = allOrgs.find(
            (org) => org.id === adminOrgs[0]?.id
          ); 

          if (encounterId && encounteredData) {
            formik.setFieldValue("orgId", encounteredData?.serviceProvider?.reference?.split("/")?.[1]);
            formik.setFieldValue("orgName", encounteredData?.serviceProvider?.display);
          }
          else if (adminOrg) {
            formik.setFieldValue("orgId", adminOrg.id);
            formik.setFieldValue("orgName", adminOrg.name);
          }
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });

    getSingleUser({
      id: user["custom:unique_id"],
      type: "Practitioner",
      userOrgId: adminOrgs?.[0]?.id
    })
      .then((res) => {
        setPractitionerData(res.data);
      })
      .catch((res) => {
        console.log("error fetching practioner list", res);
      });

    if (encounteredData?.serviceLineId) {
      formik.setFieldValue("serviceLineId", encounteredData?.serviceLineId)
    }
  }, []);

  useEffect(() => {
    formik.setFieldValue(
      "questionResponse",
      Questions?.map((item) => {
        const isTrue =
          item?.answerType === "freeText" || item?.answerType === "singleFreeText" || item?.answerType === "dropDown";
        const isDropDown = item?.answerType === "dropDown";
        return {
          ...item,
          answer: item?.answerOption?.map((option) => {
            return {
              id: option?.id,
              required: item?.required,
              answer: isTrue ? "" : false,
              option: isTrue ? isDropDown ? option.text : null : option?.text,
              value: isDropDown ? option.text : null,
              name: isDropDown ? option.text : null,
            };
          }),
        };
      })
    );
  }, [Questions]);

  useEffect(() => {
    if (formik?.values?.orgId) {
      getServiceLinesByOrgId(formik?.values?.orgId).then((res) => {
        if (res?.status === true) {
          let formattedSL = res?.data?.map((dataItem) => ({
              name: dataItem?.name,
              value: dataItem?.id,
              id: dataItem?.id
            }));
          formattedSL.sort((a, b) => a.name.localeCompare(b.name));
          setAvailableServiceLines(formattedSL)

          if (encounteredData?.serviceLineId) {
            let findMatch = res?.data?.find((item) => item?.id === encounteredData?.serviceLineId)
            if (findMatch?.name) {
              formik.setFieldValue("serviceLineName", findMatch)
            }
          } else if (formattedSL?.length === 1 && formattedSL?.[0]?.id) {
            formik.setFieldValue("serviceLineName", formattedSL?.[0])
            formik.setFieldValue("serviceLineId", formattedSL?.[0]?.id)
          } else {
            formik.setFieldValue("serviceLineId", '') 
          }
        }
      }).catch((res) => {
        failed(res?.error || res?.message || "Error getting Service Lines for Organization")
      })

    }
  }, [formik.values?.orgId])

  useEffect(() => {
    let cancelled = false;
    setIntakeReadyFor("");
    if (formik?.values?.serviceLineId && formik.values?.orgId) { 
      getServiceLineById(formik.values?.orgId, formik.values?.serviceLineId).then(async (res) => {
        if (cancelled) return;
        if(!isWaitingRoom && res?.data?.intakeQuestionnaire === "None") {
          // this is ok, go straight to patient
          setSteps(ALL_STEPS.filter(
            (step) => !(step.key === "QUESTIONS")
          ));
          formik.setFieldValue("questionnaireId", "None");
          setDisabledNext(false);
          setIntakeReadyFor(`${formik.values.orgId}:${formik.values.serviceLineId}`);
          return;
        } 
        else if(!res?.data?.intakeQuestionnaire || res?.data?.intakeQuestionnaire === "None") {
          setSteps(ALL_STEPS);
          failed("No intake questionnaire found for this service line");
          setDisabledNext(true);
          return;
        } 
        else {
          setSteps(ALL_STEPS);
          setDisabledNext(false);
        }
        const response = await getQuestionnaireById(res?.data?.intakeQuestionnaire, res?.data?.orgId);
        if (cancelled) return;
        formik.setFieldValue("questionnaireId", response?.data?.id);
        
        // Store the questionnaire definition with enableWhen from APL rules
        setQuestionnaireDefinition(response?.data);
        
        const questions = response?.data?.item?.map((item) => ({
          ...item,
          name: item?.text,
          value: item?.id,
        }));
        setQuestions(questions);

        const questionResponse = questions?.map((item) => {
          const isTrue =
            item?.answerType === "freeText" || item?.answerType === "singleFreeText" ||
            item?.answerType === "dropDown";
          const isDropDown = item?.answerType === "dropDown";
          return {
            ...item,
            questionId: item?.id || item?.linkId || null, // This must match the id in enableWhen expression
            tag: item?.tag,
            questionType: item?.answerType,
            answerType: item?.answerType,
            answer: item?.answerOption?.map((option) => {
              return {
                id: option?.id,
                required: item?.required,
                answer: isTrue ? "" : false,
                option: isTrue ? isDropDown ? option.text : null : option?.text, 
                value: isDropDown ? option.text : null,
                name: isDropDown ? option.text : null,
              };
            }),
          };
        });
        
        formik.setFieldValue("questionResponse", questionResponse);
        setIntakeReadyFor(`${formik.values.orgId}:${formik.values.serviceLineId}`);
      }).catch((res) => {
        if (cancelled) return;
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res?.message || "Error getting Service Line Intake Questionnaire"
        );
      });
    }
    return () => { cancelled = true; };
  }, [formik.values?.serviceLineId, formik.values?.orgId, isWaitingRoom])

  // Evaluate APL rules and filter visible questions - re-evaluate whenever questionResponse changes
  useEffect(() => {
    if (!questionnaireDefinition || !formik.values?.questionResponse || Questions.length === 0) {
      if (Questions.length > 0) {
        setVisibleQuestions(Questions.map(() => true));
      }
      return;
    }

    const visibility = Questions.map((question, idx) => {
      let questionnaireItem = null;
      
      questionnaireItem = questionnaireDefinition?.item?.find(q => 
        q.id === question.id && q.linkId === question.linkId
      );

      if (!questionnaireItem) {
        questionnaireItem = questionnaireDefinition?.item?.find(q => q.linkId === question.linkId);
      }

      if (!questionnaireItem) {
        questionnaireItem = questionnaireDefinition?.item?.find(q => q.id === question.id);
      }
      if (!questionnaireItem?.enableWhen) return true;
      const questionResponse = formik.values.questionResponse.map((item, index) => ({
        ...item,
        questionId: item.questionId || item.id || Questions[index]?.id || Questions[index]?.linkId || null,
        tag: item?.tag,
        questionType: item.questionType || item.answerType,
        answerType: item.answerType || item.questionType,
      }));
      
      return evaluateCondition(questionnaireItem.enableWhen.expression, questionResponse);
    });
    
    setVisibleQuestions(visibility);
  }, [questionnaireDefinition, Questions, questionResponseKey, formik.values.questionResponse]);


  useEffect(() => {
    if(formik.values?.orgId) {
      getOrganizationSettings(formik.values?.orgId)
        .then((res) => {
          setOrganizationSettings(res?.data);
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res?.message ||
              "Error getting organization settings"
          );
        });
    }
  }, [formik.values?.orgId]);

  // Watch for changes in answer values to trigger re-evaluation
  useEffect(() => {
    if (!formik.values?.questionResponse || Questions.length === 0) return;
    
    // Create a hash of all answer values to detect changes
    const answerHash = formik.values.questionResponse.map(q => {
      if (q.answerType === 'radio' || q.answerType === 'checkbox') {
        return q.answer?.filter(a => a.answer === true).map(a => a.option).join(',');
      } else {
        return q.answer?.[0]?.answer || '';
      }
    }).join('|');
    
    // Trigger re-evaluation when answers change
    const timer = setTimeout(() => {
      setQuestionResponseKey(prev => prev + 1);
    }, 50);

    return () => clearTimeout(timer);
  }, [formik.values.questionResponse?.map(q => {
    if (q.answerType === 'radio' || q.answerType === 'checkbox') {
      return q.answer?.filter(a => a.answer === true).map(a => a.option).join(',');
    } else {
      return q.answer?.[0]?.answer || '';
    }
  }).join('|'), Questions.length]);

  const orgSelectOptions = organizations.map(org => ({ label: org.name, value: org.value }));
  const serviceLineSelectOptions = availableServiceLines.map(sl => ({ label: sl.name, value: sl.id }));

  const handleOrgChange = (selected) => {
    formik.setFieldValue("orgId", selected?.value || "");
    formik.setFieldValue("orgName", selected?.label || "");
    formik.setFieldValue("serviceLineId", "");
    formik.setFieldValue("serviceLineName", "");
  };

  const handleServiceLineChange = (selected) => {
    formik.setFieldValue("serviceLineId", selected?.value || "");
    const selectedSL = availableServiceLines?.find((item) => item?.id === selected?.value);
    formik.setFieldValue("serviceLineName", selectedSL || "");
  }

  const getAnonymousPatient = (addedData) => {
    setPatient(addedData);
    formik.setFieldValue("selectedPatientData", addedData);
    formik.setFieldValue("patientId", addedData?.link[0]?.target?.reference?.split("/")?.[1] || "");
    formik.setFieldValue("patientName", addedData?.name?.[0]?.text);
    handleNext(false)
  }

  const getAddedPatient = (addedData) => {
    setPatient(addedData);
  };

  const resetPatient = (data) => {
    setPatient(data);
  };

  // if no questionnaire response id, create a new one, otherwise, update
  const handleQuestionnaireResponse = async (payload) => {
    if (questionnairResId) 
      return editQuestionnaireResponse(questionnairResId, payload)
    else
      return createQuestionnaireResponse(payload);
  }

  const activeForm = () => {
    switch (activeStep.key) {
      case "ORGANIZATION":
        return (
          <div>
          <Row>
            <Col>
              <SearchSelect
                label="Select Organization"
                required={true}
                options={orgSelectOptions}
                value={orgSelectOptions.find(opt => opt.value === formik.values.orgId) || null}
                onChange={handleOrgChange}
                placeholder="Select Organization"
                isDisabled={isOrgReadOnly}
                formik={formik}
                keyField="orgId"
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <SearchSelect
                label="Service Line"
                required={true}
                options={serviceLineSelectOptions}
                value={serviceLineSelectOptions.find(opt => opt.value === formik.values.serviceLineId) || null}
                onChange={handleServiceLineChange}
                placeholder="Select Service Line"
                isDisabled={!!encounteredData?.serviceLineId}
                formik={formik}
                keyField="serviceLineId"
              />
            </Col>
          </Row>
          </div>

          
        );
      case "QUESTIONS":
        return (
          <>
            {Questions?.length > 0 ? (
              Questions?.map((question, index) => {
                // Only render if question is visible based on APL rules
                if (!visibleQuestions[index]) return null;
                
                return (
                  <Fragment key={index}>
                    {/* <h6>{question?.text}{question?.required ? <span style={{ color: "red" }}> *</span> : null}</h6> */}
                    <Fields
                      question={question}
                      Questions={Questions}
                      formik={formik}
                      propIndex={index}
                      setRadioValue={(val) => {
                        setRadioValue(val);
                        // Force re-evaluation after a short delay to allow formik to update
                        setTimeout(() => setQuestionResponseKey(prev => prev + 1), 0);
                      }}
                    />
                    {/* <div>{formik?.errors?.questionResponse?.[index] ? <div className="error-text">Required question</div> : null}</div> */}
                  </Fragment>
                );
              })
            ) : (
              <div className="error-text">
                Assign the questionnaire to proceed.
              </div>
            )}
          </>
        );
      case "PATIENT":
        return (
          <PatientSelection
            orgId={formik?.values?.orgId}
            formikInBoundCall={formik}
            handleAddPatient={() => setPatientModal(true)}
            patient={patient}
            resetPatient={resetPatient}
            setPatient={getAnonymousPatient}
            onSearchLoadingChange={setBtnLoading}
          />
        );
      default:
        return <Col></Col>;
    }
  };

  const extractIntakeData = (values) => {
    const results = {};

    const nameQuestion = values.questionResponse.find(
      (question) => question.tag === "CALLER"
    );
    if (nameQuestion) {
      let concatenatedName = null;
      let nameAnswer = nameQuestion?.answer?.map(answer => ({ ...answer }));
      if(nameAnswer) 
        results["nameAnswer"] = nameAnswer;
      
      concatenatedName =
        nameQuestion?.answer?.[1] !== undefined
          ? nameAnswer[0]?.answer + " " + nameAnswer[1]?.answer
          : nameAnswer[0]?.answer;
      let namePatient =
        getValueQuestionnairRadio("SELFCALLING") === "Yes"
          ? values?.patientName
          : concatenatedName;
      nameAnswer.splice(1, 1);
      nameAnswer[0].answer = namePatient
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      nameAnswer[0].required = true;
      nameAnswer[0].option = null;
      nameAnswer[0].value = null;
      nameAnswer[0].name = null;
      
      if(concatenatedName) 
        results["concatenatedName"] = concatenatedName;
    }

    const telephoneQuestion = values.questionResponse.find(
      (question) => question.tag === "TELEPHONE"
    );
    if (telephoneQuestion) {
      let telephoneAnswer = telephoneQuestion?.answer?.map(answer => ({ ...answer }));
      
      if(telephoneAnswer) 
        results["telephoneAnswer"] = telephoneAnswer
      
      let concatenatedAnswerExt = null
      concatenatedAnswerExt =
        telephoneQuestion?.answer?.[1] !== undefined
          ? telephoneAnswer[0]?.answer +
            " ext " +
            telephoneAnswer[1]?.answer
          : telephoneAnswer[0]?.answer;
      telephoneAnswer.splice(1, 1);
      telephoneAnswer[0].answer = concatenatedAnswerExt.trim();
      telephoneAnswer[0].required = true;
      telephoneAnswer[0].option = null;
      telephoneAnswer[0].value = null;
      telephoneAnswer[0].name = null;

      if(concatenatedAnswerExt) 
        results["concatenatedAnswerExt"] = concatenatedAnswerExt
    }

    return results;
  }

  const buildQuestionnairePayload = (values, telephoneAnswer = null, nameAnswer = null) => {

    const setValue = item => {
      switch (item?.tag) {
        case "TELEPHONE":
          return telephoneAnswer;
        case "CALLER":
          return nameAnswer;
        default: 
          return item?.answer 
      }
    }

    const questionResponse = values.questionResponse?.map((item) => ({
      id: item?.linkId,
      tag: item?.tag,
      questionId: item?.id || null,
      question: item?.text.trim(),
      answer: setValue(item),
      questionType: item?.answerType,
      required: item?.required,
    }));
    let payload = {
      patientID: values.patientId,
      questionResponse: questionResponse,
      encounterId: encounterId,
      questionnaire: values.questionnaireId,
      authorName: user?.name[0]?.text.trim(),
      authorType: "Practitioner",
      authorId: user["custom:practitioner_id"]
    }
    return payload
  }

  const buildEncounterPayload = (values, action, intakeQuestions) => {
    let encounter = {};

    encounter.patient = {
      reference: `Patient/${values.patientId}`,
      type: "Patient",
      display: values?.patientName.trim(),    
    };
    encounter.orgId = values?.orgId;
    encounter.orgName = values?.orgName.trim();
    if (intakeQuestions) encounter.intakeQuestions = intakeQuestions;
    encounter.requestedPeriod = {
      start: encounteredData?.period?.start,
      end: null,
    };
    encounter.practitionerId = user?.["custom:practitioner_id"] ?? practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1];
    encounter.practitionerName = user?.name?.[0]?.text.trim();
    encounter.proceedWith = action;
    encounter.status = action === "WAITING_ROOM" ? "in-progress-intake" : "in-progress-waitingroom";
    encounter.period = encounteredData?.period;
    encounter.encounterId = encounterId;
    encounter.serviceLineId = values?.serviceLineId;
    encounter.serviceLine = {
      reference: `ServiceLine/${values?.serviceLineId}`,
      display: values?.serviceLineName?.name || encounteredData?.serviceLine?.display,
      type: "ServiceLine"
    };
    encounter.actor = {
      reference: `Practitioner/${
        user?.["custom:practitioner_id"] ??
        practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1]
      }`,
      display: user?.name?.[0]?.text.trim(),
      type: "Practitioner",
    };
    return encounter;
  }

  const completeIntake = async (values, action) => {
    setBtnLoading(true);
    try {
      const { nameAnswer, telephoneAnswer } = extractIntakeData(values);
      const intakeQuestions = { preferredChannel: "phone" };
      if (values.questionnaireId !== "None") {
        const result = await handleQuestionnaireResponse(
          buildQuestionnairePayload(values, telephoneAnswer, nameAnswer)
        );
        if (result?.status !== true) throw result;
        const responseId = result?.data?.id || questionnairResId;
        if (!responseId) throw new Error("The intake questionnaire could not be saved.");
        setQuestionnairResId(responseId);
        intakeQuestions.questionnaireResponseId = { reference: `QuestionnaireResponse/${responseId}` };
        intakeQuestions.callerName = nameAnswer?.[0]?.answer;
        if (telephoneAnswer) intakeQuestions.callerNumber = telephoneAnswer[0]?.answer;
        if (isTagPresent("REASON")) intakeQuestions.intakeReason = getValueQuestionnair("REASON");
        if (isTagPresent("RELATIONSHIP") && isTagPresent("SELFCALLING")) {
          intakeQuestions.callerRelationship = getValueQuestionnairRadio("SELFCALLING") === "Yes"
            ? "Self" : getValueQuestionnairDropDown("RELATIONSHIP");
        }
      }

      const organization = allOrgData?.find(org => org.id === values.orgId);
      const address = organization?.address?.[0];
      const location = values.questionResponse?.find(question => question.tag === "LOCATION")?.answer?.[0]?.answer
        || values.selectedPatientData?.address?.[0]?.state
        || practitionerData?.address?.[0]?.state
        || (address?.country && address?.state ? `${address.country}-${address.state}` : null);
      const encounterPayload = buildEncounterPayload(values, action, intakeQuestions);
      if (location) encounterPayload.patientLocation = LOCATIONS[location] || location;

      const result = await editEncounter(encounterPayload);
      if (result?.status !== true) throw result;
      localStorage.removeItem("firstName");
      localStorage.removeItem("lastName");
      if (action === "WAITING_ROOM") {
        setWaitingRoomPayload(encounterPayload);
      } else {
        navigate("/app/interaction", {
          state: {
            practitionerName: user?.name?.[0]?.text.trim(),
            practitionerId: encounterPayload.practitionerId,
            patientId: values.patientId,
            patientName: values.patientName.trim(),
            encounterId,
            currentUser: { patient: { display: values.patientName.trim() } },
            proceedWith: "COMPLETE_CALL",
            requestedPeriod: encounterPayload.requestedPeriod,
            intakeQuestions,
            period: encounteredData?.period,
            callInitiatedFrom: "inboundCall",
          },
        });
        handleShow();
      }
    } catch (error) {
      failed(error?.response?.data?.message || error?.response?.data?.error || error?.message || "Could not save the encounter.");
    } finally {
      setBtnLoading(false);
    }
    return true;
  };

  const handleClose = async (entryName) => {
    if (submissionInFlight.current || waitingRoomOpen.current) return;
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName,
      actionBtnTitle: "Yes",
      cancelBtnTitle: "No",
      actionFirst: true,
      message: "Are you sure you would like to cancel the encounter",
    });
    if (!confirmed) return;
    if(encounterId){
      if (confirmed) {
        let payload = {
          status: "cancelled",
          period: {
            start: encounteredData?.period?.start,
            end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
          },
          actor: {
            display: practitionerData?.name?.[0]?.text,
            reference: `Practitioner/${practitionerData?.id}`,
            type: "Practitioner"
          },
          class: "NULL"
        };
        setBtnLoading(true)
        return axios.put(`encounter/${encounterId}`, payload).then((res) => {
          if (res?.status === true) {
            success(res?.message)
            handleShow()
          }
        }).catch((res) => {
          failed(res?.message || "Error updating encounter")
        }).finally(() => setBtnLoading(false))
      }
    } else {
      handleShow()
    }
  }

  return (
    <>
      {waitingRoomPayload && (
        <AddToWaitingRoomModal
          data={waitingRoomPayload}
          onShow={true}
          onHide={() => setWaitingRoomPayload(null)}
          handleShow={handleShow}
        />
      )}
      {patientModal && (
        <AddPatient
          formikInBoundCall={formik}
          modalShow={patientModal}
          handleShow={() => setPatientModal(false)}
          getAddedPatient={getAddedPatient}
        />
      )}
      <Modal
        show={modalShow}
        style={{ visibility: waitingRoomPayload ? "hidden" : "visible" }}
        enforceFocus={!waitingRoomPayload}
        onHide={() => handleClose(encounterId)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdropClassName
        backdrop={"static"}
        dialogClassName="modal-xl-custom modal-xl-custom-resources"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Create New Encounter
          </Modal.Title>
          {hasResourcesReadPermissions && <Button className="custom-btn" 
            style={{ marginLeft: "auto", marginRight: "10px" }}
            title="Resources"
            variant="primary"
            onClick={() => setResourceModalShow(true)}>
              Resources
          </Button>}
          <Resources
            show={resourceModalShow}
            onHide={() => setResourceModalShow(false)}
            serviceLineId={formik.values.serviceLineId}
            encounterOrgId={formik.values.orgId}
          />
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={steps.findIndex(step => step.label == activeStep.label)}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                // if (isStepOptional(index)) {
                //     labelProps.optional = (
                //     <Typography variant="caption">Optional</Typography>
                //     );
                // }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label?.key} {...stepProps}>
                    <StepLabel {...labelProps}>{label.label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <form
                  className="common-form border-fields"
                  style={{
                    border: "1px solid #c7c7c7",
                    padding: "10px",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                >
                  {activeForm()}
                </form>
                <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 1, pt: 2 }}>
                {activeStep !== steps[0] && (
                  <Button
                    variant="secondary"
                    disabled={isBusy}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Previous
                  </Button>
                )}
                  <Box sx={{ ml: "auto", display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 1 }}>
                  {activeStep.key === "PATIENT" && isWaitingRoom && (
                    <Button variant="secondary" onClick={() => handleNext(true, "WAITING_ROOM")} disabled={disabledNext || !intakeReady || isBusy}>
                      Add to Waiting Room
                    </Button>
                  )}
                  <Button onClick={() => handleNext()} disabled={disabledNext || !intakeReady} isLoading={isBusy}>
                    {activeStep.key === "PATIENT" ? "Start Encounter" : "Next"}
                  </Button>
                  </Box>
                </Box>
              </React.Fragment>
            )}
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
}
